import { tickerItems } from "@/mocks/gossip";

export default function TickerBar() {
  const items = [...tickerItems, ...tickerItems];
  return (
    <div className="w-full bg-primary-600 text-background-50 dark:text-foreground-950">
      <div className="mx-auto flex items-center gap-3 px-4 md:px-6 h-9 overflow-hidden">
        <span className="flex items-center gap-1.5 shrink-0 rounded-md bg-background-50/15 px-2 py-1 text-xs font-medium tracking-wide">
          <i className="ri-flashlight-fill text-accent-300 w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          实时更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker">
            {items.map((item, index) => (
              <span key={index} className="whitespace-nowrap pr-10 text-xs md:text-sm opacity-95">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}